import { render, staticRenderFns } from "./FormPlan.vue?vue&type=template&id=5a4cae52&"
import script from "./FormPlan.vue?vue&type=script&lang=js&"
export * from "./FormPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports